var DoorConfigurator = function DoorConfigurator(elem) {

    var self = this;
    var $holder = elem;
    var $element = elem.find('.door-configurator');
    self.elem = $element;
    self.holder = $holder;
    
    self.init = function() {

        self.config = new Config();

        self.hasLoaded = false;
        
        var panels = self.config.getPanels();
        if (panels.length === 0 || panels[0] === '') {
            self.config.setValue('panels', 'door');
        }
        self.activePanelsFromConfig(panels);
        self.adjustTopPanelWidth();

        var accessories = self.config.getAccessories();
        if (accessories.length > 0) {
            self.activeAccessoriesFromConfig(accessories);
        }

        var color = self.config.getColor();
        var material = self.config.getMaterial();

        if (material !== '') {
            // Double check that it exists
            if ($holder.find('.section-colors #' + material).length === 0) {
                material = '';
            }
        }

        if (color !== '') {
            // Double check that it exists
            if ($holder.find('.section-colors .single[data-color="' + color + '"]').length === 0) {
                color = '';
            }
        }
        
        if (material === '' && color === '') {
            var parent = $holder.find('.section-colors .color:not(.material)').first().parent();

            if (parent.length > 0) {
                color = parent.data('color');
            } else {
                //color = 'rgb(0,0,0)';

                parent = $holder.find('.section-colors .color.material').first().parent();
                if (parent.length > 0) {
                    material = parent.attr('id');
                }
            }
        }

        if (material !== '') {
            self.setMaterial(material);
        } else if (color !== '') {
            self.setColor(color);
        }

        // Events
        $holder.find('.section-colors .color').on('click', function(e) {
            e.preventDefault();
            var parent = $(this).parents('.single:first');
            if (parent.data('images')) {
                self.setMaterial(parent.attr('id'), parent.data('images'));
            } else {
                self.setColor(parent.data('color'));
            }
        });

        $holder.find('.section-accessories .accessory').on('click', function (e) {
            e.preventDefault();

            // Only one active accessory per group!
            //$(this).toggleClass('active');

            var $this = $(this);
            var group = $this.data('group');
            if ($this.hasClass('active')) {
                $this.removeClass('active');
            } else {
                $this.addClass('active').siblings('[data-group="' + group + '"]').removeClass('active');
            }

            var accessories = self.getCurrentActiveAccessories();
            self.config.setValue('accessories', accessories.join('.'));

            self.setPrice();
            self.config.updateUrl();
        });
        
        $element.find('> .panel').on('click', function(e) {
            e.preventDefault();

            var $this = $(this);
            if ($this.hasClass('inactive'))
                return;

            // Active/deactivate skin 
            $this.toggleClass('active');

            // Selecting double doors should deactivate side panels
            if ($this.hasClass('double-door')) {
                $('.door-configurator .panel:not(.double-door)').removeClass('active');
            } else if ($this.hasClass('garage-door')) {
                $('.door-configurator .panel:not(.garage-door)').removeClass('active');
            }
            
            // Selecting side panels should disable double doors
            if ($this.hasClass('side-panel') || $this.hasClass('top-panel')) {
                $('.door-configurator .double-door, .door-configurator .garage-door').removeClass('active');
            }

            if ($('.door-configurator .double-door.active, .door-configurator .garage-door.active, .door-configurator .door.active').length === 0) {
                $('.door-configurator .door').addClass('active');
            }

            var panels = self.getCurrentActivePanels();
            self.config.setValue('panels', panels.join('.'));
            self.config.updateUrl();
            self.adjustTopPanelWidth();
            self.setPrice();

        });

        $holder.find('.section-actions a.btn.contact').on('click', function (e) {
            e.preventDefault();

            $(this).removeClass('active');

            var $formholder = $(this).siblings('.contact-form');
            $formholder.addClass('active');
        });

        $holder.find('.section-actions a.btn.reset').on('click', function (e) {
            e.preventDefault();

            self.config.setValue('panels', '');
            self.config.setValue('material', '');
            self.config.setValue('color', '');
            self.config.setValue('accessories', '');

            self.config.updateUrl();
            window.location.href = window.location.href;
        });

        setTimeout(function() {
                self.hasLoaded = true;
        }, 1000);

        self.setPrice();
    };

    self.setColor = function (color) {
        self.elem.removeClass('material');
        self.elem.find('.color').css('background-color', color);
        self.config.setValue('color', color);
        self.config.setValue('material', '');
        self.setPrice();
        self.config.updateUrl();

        // Find the name and set to product
        var $color = self.holder.find('.section-colors .single[data-color="' + color + '"]');

        $color.addClass('active').siblings().removeClass('active');

        var title = $color.data('title');
        if (title.length > 0) {
            self.holder.find('.section-productname span.material-color').text(title);
        }
    };
    
    self.adjustTopPanelWidth = function() {
        var $topPanel = $element.find('.top-panel');
        var topPanelMode = "panel";

        if ($topPanel.hasClass('inactive')) {
            topPanelMode += " inactive";
        }

        // Check which panels are active
        $element.find('.active').each(function(key, item) {
            if ($(item).hasClass('side-panel')) {
                if ($(item).hasClass('left')) {
                    topPanelMode += " left";
                }

                if ($(item).hasClass('right')) {
                    topPanelMode += ' right';
                }
            }
        });

        // Check if top panel is active
        if ($topPanel.hasClass('active')) {
            topPanelMode += " active";
        }

        // Add classes to top panel
        $topPanel.attr('class', 'top-panel ' + topPanelMode);
    };

    self.activePanelsFromConfig = function(config) {

        config = config.filter(function(item) {
            return (item != "");
        });

        for (var key in config) {
            self.elem.addClass(config[key]);
            self.elem.find('.panel#' + config[key]).addClass('active');
        }
    };

    self.getCurrentActivePanels = function() {
        var panels = [];
        self.elem.find('.panel.active').each(function(key, item) {
            var id = $(item).attr('id');
            panels.push(id);
        });
        return panels;
    };

    self.activeAccessoriesFromConfig = function (config) {

        config = config.filter(function (item) {
            return (item != "");
        });

        for (var key in config) {
            self.holder.find('.section-accessories .accessory[data-id="' + config[key] + '"]').addClass('active');
        }
    };

    self.getCurrentActiveAccessories = function () {
        var accessories = [];
        self.holder.find('.section-accessories .accessory.active').each(function (key, item) {
            var id = $(item).data('id');
            accessories.push(id);
        });
        return accessories;
    };

    self.loadMaterial = function(id) {

        var item = $('.section-colors #' + id);
        var config = item.data('images');

        if (config === null) {
            return;
        }

        self.setPrice();

        self.elem.addClass('material');

        try {
            self.setMaterialForPanel(".door", config["door"]);
            self.setMaterialForPanel(".double-door", config["double_door"]);
            self.setMaterialForPanel(".garage-door", config["garage_door"]);
            self.setMaterialForPanel(".side-panel.left", config["side_panel_left"]);
            self.setMaterialForPanel(".side-panel.right", config["side_panel_right"]);
        } catch (e) {
            console.warn(e.message);
        }


        var topPanel = self.elem.find('.top-panel');
        topPanel.find('.material').remove();

        if (config["top_panel_large"] != null) {
            var div = $('<div/>');
            div.addClass('material large');
            div.attr('style', 'background-image : url(' + config["top_panel_large"] + ')');
            topPanel.prepend(div);
        }

        if (config["top_panel_medium"] != null) {
            var div = $('<div/>');
            div.addClass('material medium');
            div.attr('style', 'background-image : url(' + config["top_panel_medium"] + ')');
            topPanel.prepend(div);
        }

        if (config["top_panel_small"] != null) {
            var div = $('<div/>');
            div.addClass('material small');
            div.attr('style', 'background-image : url(' + config["top_panel_small"] + ')');
            topPanel.prepend(div);
        }

        self.config.setValue('material', id);
    };

    self.setMaterialForPanel = function(panelId, material) {
        console.info("Setting panel material for", panelId, material);

        if (material !== null) {
            var panel = self.elem.find(panelId);

            panel.find('.material').remove();

            var materialElem = $('<div/>');
            materialElem.addClass('material');
            materialElem.attr('style', 'background-image : url(' + material + ')');
            panel.prepend(materialElem);
            panel.removeClass('inactive');

            //console.log(self.elem.find(panelId))
        }
    };

    self.setMaterial = function(id) {
        //config = JSON.parse(config);

        self.elem.addClass('material');
        self.config.setValue('material', id);
        self.config.setValue('color', '');
        self.config.updateUrl();

        // Find the name and set to product
        var $material = self.holder.find('.section-colors #' + id);

        $material.addClass('active').siblings().removeClass('active');

        var title = $material.data('title');
        if (title.length > 0) {
            self.holder.find('.section-productname span').text(title);
        }

        self.loadMaterial(id);
    };

    self.setPrice = function() {

        var color = self.config.getColor();
        var material = self.config.getMaterial();
        
        var materialId = '';
        if (color !== '') {
            materialId = 'color';

            // Double-check if it's a custom color
            var customColor = self.holder.find('.section-colors .single[data-color="' + color + '"][data-iscustomcolor="true"]');
            if (customColor.length === 1) {
                materialId = customColor.attr('id');
            }

        } else if (material !== '') {
            materialId = material.replace('material-', '');
        }

        var $wrapper = self.holder.find('.section-prices');
        if (!$wrapper || $wrapper.length === 0) {
            return;
        }

        $wrapper.find('p').removeClass('active');
        if (materialId === '') {
            return;
        }

        var panels = self.config.getPanels();
        
        var hasTopPanel = false;
        for (var i = 0; i < panels.length; i++) {

            if (panels[i] === 'top') {
                hasTopPanel = true;
                continue;
            }

            $wrapper.find('p[data-id="' + panels[i] + '"][data-material="' + materialId + '"]').addClass('active');
        }

        if (hasTopPanel) {
            $wrapper.find('p[data-id="top' + (panels.length - 1) + '"][data-material="' + materialId + '"]').addClass('active');
        }

        var accessories = self.config.getAccessories();
        for (var j = 0; j < accessories.length; j++) {
            $wrapper.find('p[data-id="' + accessories[j] + '"][data-isaccessory="true"]').addClass('active');
        }

        var sum = 0.0;
        $wrapper.find('p.active').each(function() {
            sum += parseFloat($(this).data('price'));
        });

        var formatter = new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',

            // These options are needed to round to whole numbers if that's what you want.
            minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
            maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
        });

        if (sum > 0) {
            $wrapper.find('p.sum span').text(formatter.format(sum)).parent().addClass('active');
        }

        var $formfield = self.holder.find('.contact-form form .product-information textarea');
        if ($formfield.length === 0)
            $formfield = self.holder.find('.contact-form form .produktinformation textarea');

        if ($formfield.length === 0)
            return;

        //$formfield.addClass('disabled').prop('disabled', true);

        // Gather productinformation
        var products = [];
        products.push(self.holder.find('.section-productname').text());
        self.holder.find('.section-prices p.active').each(function () {
            products.push($(this).text().trim());
        });
        $formfield.val(products.join('\r\n'));

        self.holder.find('.contact-form form .url input').val(window.location.href);
    };

    if ($holder.length) {
        self.init();
    }
};


var Config = function(){

	var self = this;

	this.keys = [ "color", "panels", "material", "accessories" ];

    this.init = function() {

        // Load key values from url on load

        for (var i in this.keys) {
            var key = this.keys[i];
            var value = this.getQueryVariable(this.keys[i]);

            if (!value) {
                value = '';
            }

            if (value) {
                value = decodeURIComponent(value);
                self.setValue(key, value);
            }
        }
    };

    this.getColor = function() {
        return this.getValue('color');
    };

    this.getPanels = function() {
        return this.getValue('panels').split('.');
    };

    this.getAccessories = function () {
        return this.getValue('accessories').split('.');
    };

    this.getMaterial = function() {
        return this.getValue('material');
    };

    this.hasValue = function(key) {
        return (this.getValue(key) !== "");
    };

    this.getValue = function(key) {
        var value = localStorage.getItem(key);
        //console.info("Reading from storage", key, value);

        if (value) {
            return value;
        } else {
            return "";
        }
    };

    this.setValue = function(key, value) {
        console.info("Saving to storage", key, value);

        value = value.replace(/ /g, '');
        localStorage.setItem(key, value);
    };

    this.removeValue = function(key) {
        //console.info("Removing value for key", key);
        localStorage.removeItem(key);
    };

    this.updateUrl = function() {
        window.history.pushState('color',
            'color',
            '?color=' +
            this.getValue("color") +
            '&panels=' +
            this.getValue("panels") +
            '&material=' +
            this.getValue("material") +
            '&accessories=' +
            this.getValue("accessories"));
    };

    this.getQueryVariable = function(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }

        return(false);
    };

	this.init();

};